import { IServiceApproval } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { IWorkItem } from 'src/app/common/contracts/work-item/work-item_T';

import { ServiceApprovalWorkItem } from 'src/app/business/serviceApproval/service-approval-work-item';
import { Command } from '../command';
import { EntityCommandHandler } from '../entity-command-handler';

@Injectable()
export class ServiceApprovalCommandHandler extends EntityCommandHandler<IServiceApproval> {
  protected workItem: IWorkItem<IServiceApproval>;

  constructor(serviceApprovalWorkItem: ServiceApprovalWorkItem) {
    super();
    this.workItem = serviceApprovalWorkItem;
  }

  canHandle(command: Command): boolean {
    return command.dtoName === 'ServiceApprovalDto';
  }
}
